<section class="dynamic-dropdown-container form-group">
	<section class="dropdown-group app-dynamic-container">
		<label for="{{id}}" class="ovale ovale-special" [ngClass]="{'ovale-animation': animate }">
			{{myLabel}}
		</label>
		<span class="required-field">{{optional}}</span>
		<span class="required-field">{{required}}</span>
		<div class="custom-select-wrapper">
		<select id="{{ id }}" #input class="form-control custom-select" [class.open]="isFocused" [ngClass]="{'is-invalid': invalid}" (blur)="onBlur()"
			(input)="onDropdownChange($event)" (focusout)="handleLabel()" (change)="passOnChange($event)"
			autocomplete="chrome-off" (focus)="isFocused = true"
    (blur)="isFocused = false">

			<!-- We handle the permissions based on statePermission -->
			<ng-container *ngIf="state && state == 'review'">
				<option value="" disabled selected hidden>{{ myLabel }}</option>

				<option value="" disabled selected hidden>{{ myLabel }}</option>
				<ng-container *ngIf="permissionState === 'assets'">
					<option *ngFor="let option of ['contributor', 'now', 'future', 'never']" [value]="option"
						[selected]="option === selectedOption">
						{{ option }}
					</option>
				</ng-container>
				<ng-container *ngIf="permissionState === 'debts'">
					<option value="" disabled selected hidden>{{ myLabel }}</option>
					<option *ngFor="let option of ['contributor', 'now', 'future', 'never']" [value]="option"
						[selected]="option === selectedOption">
						{{ option }}
					</option>
				</ng-container>
				<ng-container *ngIf="permissionState === 'dailyLife'">
					<option value="" disabled selected hidden>{{ myLabel }}</option>
					<option *ngFor="let option of ['contributor', 'now', 'future', 'never']" [value]="option"
						[selected]="option === selectedOption">
						{{ option }}
					</option>
				</ng-container>
				<ng-container *ngIf="permissionState === 'digitalLife'">
					<option value="" disabled selected hidden>{{ myLabel }}</option>
					<option *ngFor="let option of ['contributor', 'now', 'future', 'never']" [value]="option"
						[selected]="option === selectedOption">
						{{ option }}
					</option>
				</ng-container>
				<ng-container *ngIf="permissionState === 'wishes'">
					<option value="" disabled selected hidden>{{ myLabel }}</option>
					<option *ngFor="let option of ['contributor', 'now', 'future', 'never']" [value]="option"
						[selected]="option === selectedOption">
						{{ option }}
					</option>
				</ng-container>
			</ng-container>

			<ng-container *ngIf="displayContributor">
				<option value="" disabled selected hidden>{{ myLabel }}</option>
				<option *ngFor="let option of ['contributor', 'now', 'future', 'never']" [value]="option"
					[selected]="option === selectedOption">
					{{ option }}
				</option>
			</ng-container>

			<ng-container *ngIf="!displayContributor">
				<option value="" disabled selected hidden>{{ myLabel }}</option>
				<option *ngFor="let o of optionCollection" [value]="o[optionValueProperty] || o"
					[selected]="o[optionValueProperty] === selectedOption">
					{{ o[optionViewProperty] || o }}
				</option>
			</ng-container>
		</select>
		</div>

	</section>

	<section class="container-righs-content"
		*ngIf="currentSection == 'assets' || currentSection == 'debts' || currentSection == 'daily life' || currentSection == 'digital life' || currentSection == 'wishes'">
		<div class="right-content" *ngIf="contributor">
			<div class="delegate-can">This means your delegate can:</div>
			<div class="explanation-on-click">View and edit all items in your {{currentSection}} section.</div>
		</div>
		<div class="right-content" *ngIf="now">
			<div class="delegate-can">This means your delegate can:</div>
			<div class="explanation-on-click">View all items in your {{currentSection}} section.</div>
		</div>
		<div class="right-content" *ngIf="future">
			<div class="delegate-can">This means your delegate can:</div>
			<div class="explanation-on-click">View all items in your {{currentSection}} section if you pass away or lose
				mental capacity.</div>
		</div>
		<div class="right-content" *ngIf="never">
			<div class="delegate-can">This means your delegate can:</div>
			<div class="explanation-on-click">Not view or edit any items in your {{currentSection}} section.</div>
		</div>
	</section>

	<section class="warning-delegate-notification"
		*ngIf="currentSection == 'assets' || currentSection == 'debts' || currentSection == 'daily life' || currentSection == 'digital life' || currentSection == 'wishes'">
		<div class="section-info"
			*ngIf="isNFZ==false && (currentSection == 'assets' || currentSection == 'debts' || currentSection == 'daily life' || currentSection == 'digital life') && (future || never)">
			<div class="label"><i class="fa fas fa-info"></i></div>
			<div>Your delegate will not have immediate access to your financial summary.</div>
		</div>
		<div class="section-info" *ngIf="currentSection == 'wishes' && (contributor || now) && animate==true">
			<div class="label"><i class="fa fas fa-info"></i></div>
			<div>This selection means your delegate could view a copy of your will whilst you are alive, so please
				consider any confidentiality implications.</div>
		</div>
	</section>
</section>